import { useEffect, useState } from 'react';

import { Attribute } from '../../../api/attribute';

interface ProductAttributeMultiSelectProps {
    attribute: Attribute;
    onSelect: (vals: string[]) => void;
    isSelectable: (val: string, attribute: Attribute) => boolean;
    isValueVisible: (val: string, attribute: Attribute) => boolean;
}

const ProductAttributeMultiSelect = (props: ProductAttributeMultiSelectProps) => {
    const [selected, useSelected] = useState<string[]>([]);

    const getSelectedStyling = (val: string): string => {
        if (selected?.includes(val)) return 'selected';
        return '';
    };

    const Select = (val: string): void => {
        let newSelected = [...selected];
        if (newSelected?.includes(val)) {
            newSelected = newSelected.filter((v) => v !== val);
        } else {
            newSelected.push(val);
        }
        useSelected([...newSelected]);
        props.onSelect(newSelected);
    };

    useEffect(() => {
        if (selected.length === 0) {
            const validValues = props.attribute.values.filter((value) => {
                if (props.isSelectable(value, props.attribute) && props.isValueVisible(value, props.attribute)) return value;
            });
            if (validValues.length === 1) Select(validValues[0]);
        }
    });

    return (
        <div>
            <p>{props.attribute.name}</p>
            <span className='shop-attr-value-container'>
                {props.attribute.values.map((val) => {
                    if (props.isSelectable(val, props.attribute)) {
                        return (
                            <div
                                key={props.attribute.id + val}
                                className={getSelectedStyling(val)}
                                onClick={() => Select(val)}>
                                {val}
                            </div>
                        );
                    } else if (!props.isValueVisible(val, props.attribute)) {
                        return <></>;
                    } else {
                        return (
                            <div
                                key={props.attribute.id + val}
                                className='disabled'>
                                {val}
                            </div>
                        );
                    }
                })}
            </span>
        </div>
    );
};

export default ProductAttributeMultiSelect;
